export const socialPlatforms = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  youtube: 'YouTube',
  linkedin: 'LinkedIn',
  x: 'X',
  tiktok: 'TikTok',
  mastodon: 'Mastodon',
  bluesky: 'Bluesky'
};
